import { useRef } from "react";

import "./FailoverInProgress.scss";

import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    isFailoverNotSet,
    isFailoverOverInProgress,
} from "userful-chronos-app-common-js/dist/models/failover/failover";
import { useFailoverSelector } from "userful-chronos-common-store/dist/failover";
import Button from "../../button/Button";
import Input from "../../Input/Input";
import { DropContainer, UserfulConfirmationDialog } from "../../widgets";

interface IProps {}

const DELETE_KEYWORD = `I Understand`;
const keyword = `"${DELETE_KEYWORD}"`;

const FailoverInProgress = (props) => {
    const failoverStatus = useFailoverSelector((state) => state.failoverStore.failoverStatus);
    const clusterStatus = useFailoverSelector((s) => s.failoverStore.clusterStatus);
    const failoverConfig = useFailoverSelector((s) => s.failoverStore.failoverConfig);
    const { t } = useTranslation();

    const [blockUI, setBlockUI] = useState(
        !isFailoverNotSet(failoverConfig) && isFailoverOverInProgress(failoverStatus, clusterStatus),
    );
    const [ignoreFailoverStatus, setIgnoreFailoverStatus] = useState(false);
    const [ignoreConfirm, setIgnoreConfirm] = useState("");

    const [showInput, setShowInput] = useState(false);

    const ignoreFailoverRef = useRef(ignoreFailoverStatus);
    useEffect(() => {
        ignoreFailoverRef.current = ignoreFailoverStatus;
    }, [ignoreFailoverStatus]);

    useEffect(() => {
        setBlockUI(!isFailoverNotSet(failoverConfig) && isFailoverOverInProgress(failoverStatus, clusterStatus));
    }, [failoverStatus, clusterStatus, failoverConfig]);

    // This useEffect is added because during failover, sometimes UI stays stuck on the loading screen because UI does not recieve any message from backedn
    // In that case we refresh the page every 1 minute

    useEffect(() => {
        let refreshTimer;
        // Start a timer to refresh the page every minute if blockUI is true
        if (blockUI) {
            refreshTimer = setInterval(() => {
                // Check if blockUI is still true before refreshing
                if (blockUI && !ignoreFailoverRef.current) {
                    window.location.reload();
                }
            }, 60000); // 1 minute interval

            // Clear the timer if blockUI becomes false
            return () => clearInterval(refreshTimer);
        }
    }, [blockUI]);

    const handleShowInputToggle = () => setShowInput(!showInput);
    const handleIgnore = () => {
        setIgnoreFailoverStatus(true);
        setShowInput(false);
    };

    return (
        <>
            <UserfulConfirmationDialog
                show={blockUI && !ignoreFailoverStatus}
                gap={16}
                spinningElement
                noCloseButton
                varient="primary"
                title="ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressTitle"
                replaceBody={
                    <>
                        <p>{t("ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressDesc")}</p>
                        <DropContainer
                            replaceIcon={<FontAwesomeIcon icon={faEdit} />}
                            title={t("ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressCancelTitle")}
                            description={t("ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressCancelDesc")}
                        >
                            <Input
                                filedTitle={t(
                                    "ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressCancelConfirm",
                                    { keyword },
                                )}
                                placeholder={t(
                                    "ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressCancelConfirmPlaceholder",
                                    { keyword },
                                )}
                                value={ignoreConfirm}
                                onChange={(e) => setIgnoreConfirm(e.target.value)}
                            />
                            <div className="userful-buttons-container">
                                <Button variant="secondary" onClick={() => setShowInput(false)}>
                                    {t("Shared.cancel")}
                                </Button>
                                <Button
                                    variant="danger"
                                    onClick={handleIgnore}
                                    disabled={ignoreConfirm !== DELETE_KEYWORD}
                                >
                                    {t("ConfigApp.Failover.CreateFailoverGroupText.failoverInProgressCancelOK")}
                                </Button>
                            </div>
                        </DropContainer>
                    </>
                }
                replaceFooter="NO"
            />
        </>
    );
};

export default FailoverInProgress;
